import { render, staticRenderFns } from "./myOperate.vue?vue&type=template&id=0bb2ff16&scoped=true&"
import script from "./myOperate.vue?vue&type=script&lang=js&"
export * from "./myOperate.vue?vue&type=script&lang=js&"
import style0 from "./myOperate.vue?vue&type=style&index=0&id=0bb2ff16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb2ff16",
  null
  
)

export default component.exports